import { IconDefinition } from '@ant-design/icons-angular';
import {
  MenuOutline,
  BellOutline,
  MedicineBoxOutline,
  StepBackwardOutline,
  UserOutline,
  SettingOutline,
  LogoutOutline,
  DownOutline,
  CloseCircleFill,
  BulbOutline,
  EyeOutline,
  ArrowLeftOutline,
  PlusCircleFill,
  MoreOutline,
  FolderOpenOutline,
  InboxOutline,
  RestOutline,
  PlusCircleOutline,
  FilterOutline,
  CloseCircleOutline,
  GoogleOutline,
  FacebookOutline,
  HomeOutline
} from '@ant-design/icons-angular/icons';

export const icons: IconDefinition[] = [
  MenuOutline,
  BellOutline,
  MedicineBoxOutline,
  StepBackwardOutline,
  UserOutline,
  SettingOutline,
  LogoutOutline,
  DownOutline,
  CloseCircleFill,
  BulbOutline,
  EyeOutline,
  ArrowLeftOutline,
  PlusCircleFill,
  MoreOutline,
  FolderOpenOutline,
  InboxOutline,
  RestOutline,
  PlusCircleOutline,
  FilterOutline,
  CloseCircleOutline,
  GoogleOutline,
  FacebookOutline,
  HomeOutline
];
